import { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../redux/slice/user";
import { setBackLayout } from "../../redux/slice/system";
import { useNavigate } from "react-router-dom";

import { useClearLocalStorage } from "../hooks";

import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { classNames } from "primereact/utils";

export default function BackTopbar(props) {
  let { model, LayoutCss } = props;
  const system = useSelector((state) => state.system);
  const redux_user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const route_navigate = useNavigate();
  const clearLocalStorage = useClearLocalStorage();

  // 登出
  const logout = () => {
    // 清除 loacl 資料
    clearLocalStorage();

    // 導向登入畫面
    route_navigate("/login");
  };

  return (
    <>
      {["back", "self"].indexOf(model) !== -1 ? (
        <>
          <div
            id="layout-topbar"
            className={classNames(LayoutCss["layout-topbar"], {
              "h-2rem": model === "self",
            })}
          >
            {model === "back" && (
              <Button
                className="p-button-white p-button-sm p-button-outlined w-auto px-2 py-1 mr-3"
                icon="pi pi-bars"
                onClick={() =>
                  dispatch(
                    setBackLayout({
                      isSideShow: !system.backLayout.isSideShow,
                    })
                  )
                }
              />
            )}

            <span
              className={classNames(LayoutCss["layout-title"], {
                "text-xl": model === "self",
              })}
            >
              公益圖表
            </span>

            {model === "back" && (
              <>
                <div className="text-center text-white border-right-1 border-200 ml-auto pr-2 hidden lg:inline-block">
                  {redux_user?.userCompany?.name}
                </div>

                <span className="text-white ml-2 hidden lg:inline-block">
                  {redux_user.userDetail?.username
                    ? `使用者：${redux_user.userDetail?.username}`
                    : ""}
                </span>

                <Button
                  className="p-button-white p-button-sm w-auto px-2 py-1 ml-3"
                  label="登出"
                  onClick={() => logout()}
                />
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="flex align-items-center flex-shrink-0 w-full h-3rem teach-bg-sub px-3">
            <Button
              className="p-button-white p-button-sm p-button-outlined w-auto px-2 py-1"
              icon="pi pi-bars"
              onClick={() =>
                dispatch(
                  setBackLayout({
                    isSideShow: !system.backLayout.isSideShow,
                  })
                )
              }
            />
          </div>
        </>
      )}
    </>
  );
}
